import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Section } from "@/components/layout/Section";
import { Container } from "@/components/layout/Container";
import { AnimatedSection } from "@/components/ui/animated-section";

const faqs = [
  {
    question: "What file formats do you support?",
    answer: "SurviAI supports PDF, Word documents (.docx, .doc), images (PNG, JPG), and scanned documents. Our AI can extract questions from virtually any document format."
  },
  {
    question: "How accurate is the AI extraction?",
    answer: "Our AI achieves 98% accuracy in question extraction and type detection. You can always review and edit the extracted questions before publishing your survey."
  },
  {
    question: "Can I edit surveys after they're generated?",
    answer: "Absolutely! After AI extraction, you have full control to edit questions, change question types, add logic and branching, reorder questions, and customize the design."
  },
  {
    question: "How do I share surveys with respondents?",
    answer: "Share surveys via a unique link, embed them on your website, or send email invitations directly from SurviAI. You can also generate QR codes for easy mobile access."
  },
  {
    question: "Is my data secure?",
    answer: "Yes. We use 256-bit encryption, are SOC2 compliant, and GDPR ready. Your data is stored securely and never shared with third parties."
  },
  {
    question: "Do you offer a free trial?",
    answer: "Yes! Start with our free tier which includes 3 surveys per month and 100 responses. No credit card required. Upgrade anytime to unlock more features."
  },
  {
    question: "Can I export my data?",
    answer: "Yes, export your survey responses to CSV, Excel, or connect via our API. Pro and Enterprise plans include advanced export options and integrations."
  },
  {
    question: "What question types are supported?",
    answer: "We support all major question types: multiple choice, single choice, text input, rating scales, matrix questions, ranking, sliders, date/time pickers, and more."
  },
];

export function FAQ() {
  return (
    <Section id="faq">
      <Container className="max-w-3xl">
        <AnimatedSection className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground">
            Frequently Asked <span className="text-gradient">Questions</span>
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">
            Everything you need to know about SurviAI
          </p>
        </AnimatedSection>
        
        <AnimatedSection delay={0.2}>
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`} className="border-border">
                <AccordionTrigger className="text-left text-foreground hover:text-primary transition-colors">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </AnimatedSection>
      </Container>
    </Section>
  );
}
